// client/src/App.js
import React, { lazy, Suspense, memo } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './navbar';
import Footer from './footer';
import GAListener from './GAListener';

const HomePage = lazy(() => import('./home'));
const AboutPage = lazy(() => import('./about'));
const ContactPage = lazy(() => import('./contact'));
const PageNotFound = lazy(() => import('./404'));
const DonationThankYouPage = lazy(() => import('./thankYouPage'))

// Coffee brewing
const BrewingTableOfContents = lazy(() => import("./brewing-pages/coffee-brewing/brewingTableOfContents"))
const BrewingCappuccino = lazy(() => import("./brewing-pages/coffee-brewing/milk-drinks/brewingCappuccino"))
const BrewingAmericanoWithAeropress = lazy(() => import("./brewing-pages/coffee-brewing/aeropress/brewingAmericano"))
const CoffeeRoastLevels = lazy(() => import("./brewing-pages/coffee-brewing/coffee-beans/understandingRoastLevel"))

// Espresso Basics
const EspressoTableOfContents = lazy(() => import("./brewing-pages/coffee-brewing/espressoTableOfContents"))
const PuckPrepartion = lazy(() => import("./brewing-pages/coffee-brewing/espresso/puckPreparation"))

// Coffee Beans
const CoffeeBeansTableOfContents = lazy(() => import("./brewing-pages/coffee-brewing/coffeeBeansTableOfContents"))
const ChoosingCoffeeBeans = lazy(() => import("./brewing-pages/coffee-brewing/coffee-beans/choosingCoffeeBeans"))

const App = () => (
  <BrowserRouter>
    <GAListener />
    <Suspense fallback={<div>Please Wait...</div>}>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Navbar />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path="/donation-thank-you" element={<DonationThankYouPage />} />

            {/* Coffee brewing */}
            <Route path="/brewing-pages/" element={<BrewingTableOfContents />} />
            <Route path="/brewing-pages/coffee-brewing/milk-drinks/how-to-brew-cappuccino" element={<BrewingCappuccino />} />
            <Route path="/brewing-pages/coffee-brewing/aeropress/how-to-brew-americano-with-aeropress" element={<BrewingAmericanoWithAeropress />} />

            {/* Espresso Basics */}
            <Route path="/espresso/" element={<EspressoTableOfContents />} />
            <Route path="/espresso/how-to-prepare-your-coffee-puck" element={<PuckPrepartion />} />

            {/* Coffee Beans */}
            <Route path="/coffee-beans" element={<CoffeeBeansTableOfContents />} />
            <Route path="/coffee-beans/how-to-choose-the-right-coffee-beans-for-your-brew" element={<ChoosingCoffeeBeans />} />
            <Route path="/coffee-beans/understanding-coffee-roast-levels" element={<CoffeeRoastLevels />} />

            {/* Old URLs redirects */}
            <Route
              path="/brewing-pages/coffee-brewing/how-to-brew-americano-with-aeropress"
              element={<Navigate to="/brewing-pages/coffee-brewing/aeropress/how-to-brew-americano-with-aeropress" replace />}
            />
            <Route
              path="/brewing-pages/coffee-brewing/how-to-brew-cappuccino"
              element={<Navigate to="/brewing-pages/coffee-brewing/milk-drinks/how-to-brew-cappuccino" replace />}
            />
            <Route
              path="/brewing-pages/coffee-brewing/espresso/how-to-prepare-your-coffee-puck"
              element={<Navigate to="/espresso/how-to-prepare-your-coffee-puck" replace />}
            />
            
            {/* Catch-all for 404 */}
            <Route path='*' element={<PageNotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Suspense>
  </BrowserRouter>
);

export default memo(App);
